export default "__VITE_ASSET__D7PId73e__"